import React from "react";
import UserProfilePresenter from "./UserProfilePresenter";
import ReporterType from "../../infra/aggregates/reportsToInterface";

interface eventList {
  reporter: ReporterType;
  isDashboard?: boolean;
}
const UserProfileController = ({ reporter, isDashboard }: eventList) => {
  return <UserProfilePresenter reporter={reporter} isDashboard={isDashboard} />;
};
export default UserProfileController;
